/**
 * @TODO 공용 유틸 함수
 */
// React Calendar 한글화 세팅
export const koreanWeekdays = ["일", "월", "화", "수", "목", "금", "토"];
export const koreanMonths = ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"];

export const renderWeekday = ({ weekday }) => {
    return <div>{koreanWeekdays[weekday]}</div>;
};

export const formatMonthYear = (locale, date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return `${year}년 ${koreanMonths[month]}`;
};

export const formatSelectedDate = (date) => {
    const opts = { month: "2-digit", day: "2-digit", weekday: "short" };
    const formatted = date
        .toLocaleDateString("ko-KR", opts)
        .replace(". ", "월 ")
        .replace(". ", "일 ")
        .replace(/\s*\([^)]+\)/, (m) => ` (${m.trim().slice(1, 2)})`); // 요일의 첫 글자만 사용

    return {
        date: date,
        formatted: formatted,
    };
};

export function dateFormat(date) {
    if (!date) return "-";
    let target = new Date(date);

    return target.getFullYear() + "년 " + (target.getMonth() + 1) + "월 " + target.getDate() + "일 ";
}

export const dateFormatDateTimeApi = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export function dateFormatFull(date) {
    const opts = { year: "2-digit", month: "2-digit", day: "2-digit", weekday: "long" };
    const formatted = date
        .toLocaleDateString("ko-KR", opts)
        .replace(". ", "년 ")
        .replace(". ", "월 ")
        .replace(". ", "일 ")
        .replace(/\s*\([^)]+\)/, (m) => `${m}`);

    return formatted;
}

export function dateFormatDash(date) {
    let target = new Date(date);
    let month = (target.getMonth() + 1).toString().padStart(2, "0");
    let day = target.getDate().toString().padStart(2, "0");

    return target.getFullYear() + "-" + month + "-" + day;
}

export function dateFormatToISOString(date, type = "start") {
    // UTC 시간으로 변환
    let utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

    // ISO 8601 형식으로 변환
    let formattedDate;
    if (type === "start") {
        formattedDate = utcDate.toISOString().split("T")[0] + "T00:00:00.000Z";
    } else if (type === "end") {
        formattedDate = utcDate.toISOString().split("T")[0] + "T23:59:59.999Z";
    }

    return formattedDate;
}

// 시간 포맷 (타이머)
export const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
};

// 날짜 포맷
export const dateFormatDateTime = (inputDate, format = "YYYY-MM-DD HH:mm") => {
    // 사용 예시
    // dateFormatDateTime("2024-06-10T17:32:50.955", "YYYY");
    // dateFormatDateTime("2024-06-10T17:32:50.955", "YYYY.MM.DD");
    // dateFormatDateTime("2024-06-10T17:32:50.955", "YYYY-MM-DD");
    // dateFormatDateTime("2024-06-10T17:32:50.955", "YYYY-MM-DD HH:mm");
    // dateFormatDateTime("2024-06-10T17:32:50.955", "YYYY-MM-DD HH:mm:ss");
    if (!inputDate) return null;

    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    if (format === "YYYY") {
        return `${year}`;
    } else if (format === "YYYY.MM.DD") {
        return `${year}.${month}.${day}`;
    } else if (format === "YYYY-MM-DD") {
        return `${year}-${month}-${day}`;
    } else if (format === "YYYY-MM-DD HH:mm") {
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    } else if (format === "YYYY-MM-DD HH:mm:ss") {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        throw new Error("Invalid format specified");
    }
};

// 날짜 포맷
export const timeFormat = (inputDate) => {
    const date = new Date(inputDate);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
};

// 천단위 콤마 포맷 변환
export const comma = (str) => {
    if (!str) return "";
    const integerPart = String(str).split(".")[0]; // 소수점 이하 제거
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const uncomma = (str) => {
    str = String(str);
    return str.replace(/[^\d]+/g, "");
};

// 숫자만 입력 받는 공통 함수
const sanitizeNumericInput = (input) => input.replace(/[^0-9]/g, "");

// 쉼표 추가 함수
const addCommas = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

// 숫자만 입력 및 쉼표 추가
export const formatNumberWithCommas = (e) => {
    let sanitizedValue = sanitizeNumericInput(e.target.value);
    // 맨 앞의 불필요한 0 제거
    sanitizedValue = sanitizedValue.replace(/^0+(\d)/, "$1");
    e.target.value = addCommas(sanitizedValue);
};

// 숫자만 입력
export const onlyNumericInput = (e) => {
    e.target.value = sanitizeNumericInput(e.target.value);
};

// 숫자, 소수점만 입력
export const formatDecimalInput = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d.]/g, "");
    const parts = value.split(".");
    if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
    }
    e.target.value = value;
};

/**
 * @TODO 커스텀 유틸 함수
 */

// 사용연수 반환
export const convertDaysToMonthsAndDays = (days) => {
    const daysInMonth = 30; // 한 달을 30일로 가정
    const months = Math.floor(days / daysInMonth);
    const remainingDays = days % daysInMonth;

    return `${months}개월 ${remainingDays}일`;
};

// 차량 연식 반환 (IN: 2013-01-07 / OUT: 2013.01)
export const formatProductYearMonth = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");

    return `${year}.${month}`;
};

export const calculateAge = (birthDate) => {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();

    // 생일이 지났는지 여부 확인 (월/일 비교)
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--; // 생일이 아직 안 지났다면 나이 1 감소
    }

    return age;
};

// 주민번호 7자리 입력 시 한국 나이 계산
export const computeAgeText = (driverData) => {
    if (driverData.idNumber && driverData.idNumber.length >= 7) {
        const idStr = driverData.idNumber;
        const yy = parseInt(idStr.substring(0, 2));
        const mm = parseInt(idStr.substring(2, 4));
        const dd = parseInt(idStr.substring(4, 6));
        const indicator = idStr.charAt(6);
        // 간단한 기준: 1,2는 1900년대, 그 외는 2000년대로 가정
        const century = indicator === "1" || indicator === "2" ? 1900 : 2000;
        const birthDate = new Date(century + yy, mm - 1, dd);
        return `만 ${calculateAge(birthDate)}세`;
    }
    return "";
};

export const computeYoungestAge = (drivers) => {
    if (!drivers || drivers.length === 0) return "";
    const ages = drivers.map((driver) => {
        if (driver.idNumber && driver.idNumber.length >= 7) {
            const idStr = driver.idNumber;
            const yy = parseInt(idStr.substring(0, 2));
            const mm = parseInt(idStr.substring(2, 4));
            const dd = parseInt(idStr.substring(4, 6));
            const indicator = idStr.charAt(6);
            // 1,2는 1900년대, 그 외는 2000년대로 가정
            const century = indicator === "1" || indicator === "2" ? 1900 : 2000;
            const birthDate = new Date(century + yy, mm - 1, dd);
            return calculateAge(birthDate);
        }
        return Infinity; // 주민번호 미입력 시 무시
    });
    const minAge = Math.min(...ages);
    return isFinite(minAge) ? `만 ${minAge}세` : "";
};

export const driverRangeText = (drivers) => {
    if (!drivers || drivers.length === 0) return "";
    if (drivers.length === 1) return "계약자 1명";
    else return `계약자 외 ${drivers.length - 1}인`;
};

// 금액(숫자)를 한국 원화 형식(예: 50만원)으로 변환하는 공통 함수
export const formatCurrency = (amount) => {
    if (amount == null) return "";
    // 예를 들어 selfPay 값이 5000이면 5000 * 100 = 500,000원
    // 500,000원을 만원 단위로 표기하면 500,000 / 10,000 = 50만원
    const won = amount * 100;
    return won >= 10000 ? `${won / 10000}만원` : `${won.toLocaleString("ko-KR")}원`;
};

export const formatInsuranceCurrency = (amount) => {
    if (amount == null) return "";
    const num = Number(amount);
    if (isNaN(num)) return "";
    return num >= 10000 ? `${num / 10000}만원` : `${num.toLocaleString("ko-KR")}원`;
};

// 두 날짜 사이의 일수와 시간 차이를 계산
export function calculateRentalDuration(startedAt, endedAt) {
    if (!startedAt || !endedAt) {
        return { days: 0, hours: 0 };
    }
    const start = new Date(startedAt);
    const end = new Date(endedAt);
    const diffMs = end - start;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const totalMinutes = Math.floor(diffMs / 60000); // 분 단위로 변환
    return { days, hours, totalMinutes };
}

// 주민등록번호 하이픈 처리
export const formatIdNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 13);
    if (cleaned.length <= 6) return cleaned;
    return `${cleaned.slice(0, 6)}-${cleaned.slice(6)}`;
};

// 주민등록번호 하이픈 처리
export const formatIdNumberBackNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 13);
    if (cleaned.length <= 6) return cleaned;
    return `${cleaned.slice(0, 6)}-${cleaned.charAt(6)}******`;
};

// 사업자번호 하이픈 처리
export const formatBizNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // 숫자만, 10자리까지
    const len = cleaned.length;

    if (len <= 3) return cleaned;
    if (len <= 5) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
};

// 날짜 형식 변환 (YYYY.MM.DD)
export const formatDate = (value) => {
    if (!value) return "";
    const cleaned = String(value).replace(/\D/g, "").slice(0, 8); // 숫자만, 8자리까지
    const len = cleaned.length;

    if (len <= 4) return cleaned;
    if (len <= 6) return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`;
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6)}`;
};

// 성함 마스킹
export const maskName = (name) => {
    if (!name) return "";
    return name.length >= 2 ? name[0] + "*" + name.slice(2) : name;
};

// 핸드폰번호 마스킹
export const maskPhone = (phone) => {
    if (!phone || phone.length !== 11) return "-";
    return `${phone.slice(0, 3)}****${phone.slice(7)}`;
};

export const isValidDateFormat = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(dateString);
};

export const isValidDate = (dateString) => {
    // 1. 형식 확인 (YYYY-MM-DD)
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    // 2. 날짜 객체로 파싱
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(dateString);

    // 3. 실제 날짜와 비교 (예: 2025-02-30은 존재하지 않음)
    return (
        date.getFullYear() === year &&
        date.getMonth() + 1 === month && // JS에서 month는 0부터 시작하므로 +1
        date.getDate() === day
    );
};

export const formatPhoneNumber = (value) => {
    if (!value) return "";
    const onlyNums = value.replace(/[^0-9]/g, "");

    if (onlyNums.length <= 3) return onlyNums;
    if (onlyNums.length <= 7)
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    if (onlyNums.length <= 11)
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7)}`;
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7, 11)}`;
};

// 선택된 차량 연식이 현재 기준 8년 이상 지난 경우(예: currentYear - 8 이하)
// 예를 들어, 현재 연도가 2025라면, 2016년 이하이면 메시지 반환
export const validateCarYear = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    if (selectedYear <= currentYear - 8) {
        return "연한초과 차량입니다. 진행에 참고 바랍니다.";
    }
    return "";
};

export const validateCarNumber = (carNumber) => {
    const carNumberRegex = /^([0-9]{2,3}[가-힣])[0-9]{4}$/;
    return carNumberRegex.test(carNumber);
};

/**
 * DatePicker에서 사용할 시간대 보정 함수들
 */

// UTC 시간을 로컬 시간으로 변환 (DatePicker의 selected 속성에 사용)
export const convertUTCToLocal = (utcDate) => {
    if (!utcDate) return null;
    console.log('utcDate');
    console.log(utcDate);
    //return new Date(new Date(utcDate).getTime() + new Date().getTimezoneOffset() * 60000);
    return new Date(utcDate.getTime() + 9 * 60 * 60 * 1000).toISOString();
};

// 로컬 시간을 UTC로 변환 (DatePicker의 onChange에 사용)
export const convertLocalToUTC = (localDate) => {
    if (!localDate) return null;
    return new Date(localDate.getTime() - new Date().getTimezoneOffset() * 60000);
};

/**
 * 시간/분 선택 관련 공통 함수들
 */

// 시간 옵션 생성 (00~23)
export const generateHourOptions = () => {
    return Array.from({ length: 24 }, (_, i) => ({
        value: i.toString().padStart(2, '0'),
        label: `${i.toString().padStart(2, '0')}시`
    }));
};

// 분 옵션 생성 (00~59)
export const generateMinuteOptions = () => {
    return Array.from({ length: 60 }, (_, i) => ({
        value: i.toString().padStart(2, '0'),
        label: `${i.toString().padStart(2, '0')}분`
    }));
};

// 날짜와 시간을 합쳐서 Date 객체로 변환하는 함수
export const combineDateTime = (date, hour, minute) => {
    if (!date) return null;
    const newDate = new Date(date);
    newDate.setHours(parseInt(hour || '00'), parseInt(minute || '00'), 0, 0);
    return newDate;
};

// Date 객체에서 날짜, 시간, 분을 분리하는 함수
export const extractDateTime = (dateTime) => {
    if (!dateTime) return { date: null, hour: '00', minute: '00' };
    const date = new Date(dateTime);
    return {
        date: date,
        hour: date.getHours().toString().padStart(2, '0'),
        minute: date.getMinutes().toString().padStart(2, '0')
    };
};

// 보험 나이 계산 함수 (YYYY-MM-DD 형식용)
export const calculateInsuranceAge = (birthDateString) => {
    if (!birthDateString) return "-";

    try {
        const today = new Date();
        const birthDate = new Date(birthDateString);

        if (isNaN(birthDate.getTime())) return "-";

        let age = today.getFullYear() - birthDate.getFullYear();

        // 생일이 지났는지 여부 확인
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--; // 생일이 아직 안 지났다면 나이 1 감소
        }

        return age + "세";
    } catch (error) {
        return "-";
    }
};
